import React, { useEffect, useState } from 'react';
import { RangeConnectorParams } from 'instantsearch.js/es/connectors/range/connectRange';
import { useRange } from 'react-instantsearch';
import dayjs from 'dayjs';

type DateRangeProps = {
  label: string;
  labels: { min: string; max: string };
} & RangeConnectorParams;

const DateRange = ({ labels, ...props }: DateRangeProps) => {
  const { start, range, refine } = useRange(props);

  const { min, max } = range;
  const [dates, setDates] = useState({ min, max });

  const from = Math.max(
    min as number,
    (Number.isFinite(start[0] as number) ? start[0] : min) as number
  );

  const to = Math.min(
    max as number,
    (Number.isFinite(start[1] as number) ? start[1] : max) as number
  );

  useEffect(() => {
    setDates({ min: from, max: to });
  }, [from, to]);

  const convertToString = (timestamp: number) =>
    dayjs.unix(timestamp).format('YYYY-MM-DD');

  return (
    <div className="event-list__facet event-list__facet--date-range">
      <p className="typo-copy font-bold">{props.label}</p>
      <div className="event-list__date-range">
        <div className="input">
          <label className="typo-form-label">{labels.min}</label>
          <input
            placeholder={dayjs.unix(range.min as number).format('DD.MM.YYYY')}
            value={convertToString(dates.min as number)}
            min={convertToString(Math.floor(Date.now() / 1000))}
            max={convertToString(dates.max as number)}
            type="date"
            onBlur={() => refine([dates.min, dates.max])}
            onChange={(e) =>
              setDates((prev) => ({
                min: e.target.valueAsNumber / 1000,
                max: prev.max
              }))
            }
          />
        </div>

        <div className="input">
          <label className="typo-form-label">{labels.max}</label>
          <input
            type="date"
            value={convertToString(dates.max as number)}
            min={convertToString(dates.min as number)}
            max={convertToString(range.max as number)}
            onBlur={() => refine([dates.min, dates.max])}
            onChange={(e) =>
              setDates((prev) => ({
                max: e.target.valueAsNumber / 1000,
                min: prev.min
              }))
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DateRange;
